// 用户角色
export const USER_ROLE = {
  1: "教师",
  2: "助教",
  3: "学生",
};
export const USER_ROLE_NAME = {
  1: "teacher",
  2: "assistant",
  3: "student",
};
